<template>
  <div id="tariff-table" class="tariff-table-search app-main-content">
    <div ref="detailsView" class="details-view">
      <search-item
        ref="tariffTable"
        :key="223201"
        :show-simple="false"
        :expand-adv="true"
        reset
        :retain-default-value="true"
        config-module="223201"
        :custom-search-items="customSearchItems"
        :grid-config-module="gridConfigModule"
        @perConfigChange="value=>{perConfigName=value}"
        @query="queryHandler"
      >
        <template slot="operations">
          <el-button style="margin-left: 5px" type="primary" no="1" :title="$t('Pricing.ConfigureTheSurchargeTips')" @click="configureTheSurcharge">{{ $t("Pricing.ConfigureTheSurcharge") }}</el-button>
          <el-button type="primary" no="2" :title="$t('Pricing.TariffTableExportExcelTips')" @click="exportExcel">{{ $t("CargoMsg.Cargo_ExcelExport") }}</el-button>

          <cargo-advance-select
            no="level"
            style="width: 115px;display: inline-block;margin: 0px 5px;"
            filterable
            :clearable="false"
            :select-type="selectTypeNames.local_cache_PriceConstant$PRICE_LEVELS"
            :default-value="filter.level"
            @parentCallBack="onLevelChanged"
          />
          <!--          <cargo-advance-select-->
          <!--            no="currency"-->
          <!--            style="width: 115px;display: inline-block;"-->
          <!--            filterable-->
          <!--            :clearable="false"-->
          <!--            :select-type="selectTypeNames.basic_data_Currency"-->
          <!--            :default-value="filter.currency"-->
          <!--            @parentCallBack="changeCurrency"-->
          <!--          />-->
        </template>
      </search-item>
      <div class="tabs-container">
        <el-tabs
          ref="tabs"
          v-model="tabName"
          type="card"
          style="width:100%"
          @tab-click="handleTabClick"
        >
          <el-tab-pane
            :key="3"
            :lazy="true"
            name="AllFreightRates"
            :label="$t('CargoMsg.Cargo_All')"
          >
            <div class="grid-view">
              <div class="main-content">
                <div class="section grid-wrapper">
                  <cargo-ag-grid
                    config-module="22320104"
                    :per-config-name="perConfigName"
                    :grid-params.sync="allGridParams"
                    :grid-options="allGridOptions"
                    :column-defs="allColumnDefs"
                    :row-data="allRowData"
                    style="width:100%;"
                  />
                </div>
                <div class="pagination-wrapper">
                  <cargo-pagination
                    :total="all.total"
                    config-module="22320104"
                    :page.sync="all.pageNum"
                    :limit.sync="all.pageSize"
                    :page-count="all.pageCount"
                    @pagination="()=>{if(all.total>0){queryHandler()}}"
                  />
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :key="1"
            :lazy="true"
            name="TraditionalFreightRates"
            :label="$t('Pricing.TraditionalFreightRates')"
          >
            <div class="grid-view">
              <div class="main-content">
                <div class="section grid-wrapper">
                  <cargo-ag-grid
                    config-module="22320102"
                    :per-config-name="perConfigName"
                    :grid-params.sync="traditionalGridParams"
                    :grid-options="traditionalGridOptions"
                    :column-defs="traditionalColumnDefs"
                    :row-data="traditionalRowData"
                    style="width:100%;"
                  />
                </div>
                <div class="pagination-wrapper">
                  <cargo-pagination
                    :total="traditional.total"
                    config-module="22320102"
                    :page.sync="traditional.pageNum"
                    :limit.sync="traditional.pageSize"
                    @pagination="()=>{if(traditional.total>0){queryHandler()}}"
                  />
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            :key="2"
            :lazy="true"
            name="SpotFreightRates"
            :label="$t('Pricing.SpotFreightRates')"
          >
            <div class="grid-view">
              <div class="main-content">
                <div class="section grid-wrapper">
                  <cargo-ag-grid
                    config-module="22320103"
                    :per-config-name="perConfigName"
                    :grid-params.sync="spotGridParams"
                    :grid-options="spotGridOptions"
                    :column-defs="spotColumnDefs"
                    :row-data="spotRowData"
                    style="width:100%;"
                  />
                </div>
                <div class="pagination-wrapper">
                  <cargo-pagination
                    :total="spot.total"
                    config-module="22320103"
                    :page.sync="spot.pageNum"
                    :limit.sync="spot.pageSize"
                    @pagination="()=>{if(spot.total>0){queryHandler()}}"
                  />
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div v-if="tabName !== 'TraditionalFreightRates'" :class="tipWidth" style="position: absolute; margin: 10px;">
          <span>{{ $t('Pricing.SpotContainerWeightTips') }}</span>
        </div>
      </div>
    </div>
    <configure-the-surcharge-dialog
      v-if="configureTheSurchargeDialog.visible"
      ref="configureTheSurchargeDialog"
      :visible="configureTheSurchargeDialog.visible"
      @onClose="configureTheSurchargeDialog.visible=false"
      @reload="reload"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { queryTariffTable, transformedTariffTableExcel } from '@/api/price/priceFcl'
import dateUtils from '@/utils/dateUtils'
import { deepClone } from '@/utils'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ConfigureTheSurchargeDialog from '@/views/cargo/v0/Price/TariffTable/configureTheSurchargeDialog'
import { querySurchargeFclConfig } from '@/api/price/surchargeFcl'
import {
  getExcelWbMoreSheetByGroup
} from '@/utils/tableDataExportUtils'
import { destoryView, refreshView } from '@/store/modules/tagsView'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import { getObjectByCache } from '@/utils/basicDataCache'
import XLSX from 'sheetjs-style'
import convertResToBlob from '@/utils/convertResToBlob'
import { getLoading } from '@/utils/utilBaseElement'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'

export default {
  name: 'TariffTable',
  components: { ConfigureTheSurchargeDialog, CargoAdvanceSelect, searchItem },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      perConfigName: '',
      tabName: 'AllFreightRates',
      customSearchItems: [],
      view: 1,
      authedLevel: 0,
      filter: {
        currency: 'USD',
        level: '1'
      },
      fullscreenLoading: null,
      configureTheSurchargeDialog: {
        visible: false
      },
      traditionalGridParams: {},
      spotGridParams: {},
      allGridParams: {},
      traditionalColumnDefs: [
        {
          headerName: ' ', checkboxSelection: true, maxWidth: 40,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          } },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.Vessel'), field: 'vessel', colId: 'vessel', width: 200
        },
        { headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', colId: 'voyageFlight', width: 200
        },
        { headerName: 'ETD', field: 'etd', colId: 'etd', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.Days'), field: 'days', colId: 'days', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.daysColumnLabelFunc(params.data, params.data.days)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return PriceUtils.daysColumnLabelFunc(params.data, params.data.days)
          } },
        { headerName: this.$t('Pricing.Lane'), field: 'lane', colId: 'lane', width: 200 },
        { headerName: this.$t('Pricing.Dock'), field: 'dock', colId: 'dock', width: 200 },
        { headerName: this.$t('Pricing.DestinationDock'), field: 'destinationDock', colId: 'destinationDock', width: 200 },
        {
          headerName: this.$t('Pricing.Direct'), field: 'direct', colId: 'direct', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200, hide: true },
        {
          headerName: '20\'(' + this.$t('Pricing.Traditional') + ')', field: 'cost20', colId: 'cost20', width: 200,
          cellRenderer: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.priceColumnLabelFunc(params))
          }
        },
        {
          headerName: '40\'(' + this.$t('Pricing.Traditional') + ')', field: 'cost40', colId: 'cost40', width: 200,
          cellRenderer: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.priceColumnLabelFunc(params))
          }
        },
        {
          headerName: '40\' HC(' + this.$t('Pricing.Traditional') + ')', field: 'costhc', colId: 'costhc', width: 200,
          cellRenderer: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.priceColumnLabelFunc(params))
          }
        },
        {
          headerName: '20\' NOR(' + this.$t('Pricing.Traditional') + ')', field: 'cost20nor', colId: 'cost20nor', width: 200,
          cellRenderer: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.priceColumnLabelFunc(params))
          }
        },
        {
          headerName: '40\' NOR(' + this.$t('Pricing.Traditional') + ')', field: 'cost40nor', colId: 'cost40nor', width: 200,
          cellRenderer: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.priceColumnLabelFunc(params))
          }
        },
        {
          headerName: '45\'(' + this.$t('Pricing.Traditional') + ')', field: 'cost45', colId: 'cost45', width: 200,
          cellRenderer: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.priceColumnLabelFunc(params))
          }
        },
        { headerName: 'Free Time' + '(' + this.$t('Pricing.Traditional') + ')', field: 'freeTime', colId: 'freeTime', width: 200,
          cellRenderer: (params) => {
            if (!params.data) {
              return ''
            }
            return this.freeTimeLabel(params.data.priceFclExtra)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DestinationPort') + this.$t('CargoMsg.Cargo_Airline'), field: 'podLane', colId: 'podLane', width: 200, hide: true, suppressColumnsToolPanel: true,
          cellRenderer: (params) => {
            return this.regionLabel(params)
          }
        },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          hide: true
        },
        { headerName: this.$t('Pricing.CabinState'), field: 'priceState', colId: 'priceState', width: 100,
          cellRenderer: (params) => {
            return PriceUtils.priceStateLabelFunc(params.value)
          }
        }
      ],
      traditionalGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      traditionalRowData: [],
      traditional: {
        freightType: 0,
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      spotColumnDefs: [
        {
          headerName: ' ', checkboxSelection: true, maxWidth: 40,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          } },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.Vessel'), field: 'vessel', colId: 'vessel', width: 200
        },
        { headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', colId: 'voyageFlight', width: 200
        },
        { headerName: 'ETD', field: 'etd', colId: 'etd', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.Days'), field: 'days', colId: 'days', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.daysColumnLabelFunc(params.data, params.data.days)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return PriceUtils.daysColumnLabelFunc(params.data, params.data.days)
          } },
        { headerName: this.$t('Pricing.Lane'), field: 'lane', colId: 'lane', width: 200 },
        { headerName: this.$t('Pricing.Dock'), field: 'dock', colId: 'dock', width: 200 },
        { headerName: this.$t('Pricing.DestinationDock'), field: 'destinationDock', colId: 'destinationDock', width: 200 },
        {
          headerName: this.$t('Pricing.Direct'), field: 'direct', colId: 'direct', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200, hide: true },
        {
          headerName: '20\'(' + this.$t('Pricing.ECommerce') + ')', field: 'cost20', colId: 'cost20', width: 200,
          cellRenderer: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.priceColumnLabelFunc(params))
          }
        },
        {
          headerName: '40\'(' + this.$t('Pricing.ECommerce') + ')', field: 'cost40', colId: 'cost40', width: 200,
          cellRenderer: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.priceColumnLabelFunc(params))
          }
        },
        {
          headerName: '40\' HC(' + this.$t('Pricing.ECommerce') + ')', field: 'costhc', colId: 'costhc', width: 200,
          cellRenderer: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.priceColumnLabelFunc(params))
          }
        },
        {
          headerName: '20\' NOR(' + this.$t('Pricing.ECommerce') + ')', field: 'cost20nor', colId: 'cost20nor', width: 200,
          cellRenderer: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.priceColumnLabelFunc(params))
          }
        },
        {
          headerName: '40\' NOR(' + this.$t('Pricing.ECommerce') + ')', field: 'cost40nor', colId: 'cost40nor', width: 200,
          cellRenderer: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.priceColumnLabelFunc(params))
          }
        },
        {
          headerName: '45\'(' + this.$t('Pricing.ECommerce') + ')', field: 'cost45', colId: 'cost45', width: 200,
          cellRenderer: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.priceColumnLabelFunc(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.priceColumnLabelFunc(params))
          }
        },
        { headerName: 'Free Time' + '(' + this.$t('Pricing.ECommerce') + ')', field: 'freeTime', colId: 'freeTime', width: 200,
          cellRenderer: (params) => {
            if (!params.data) {
              return ''
            }
            return this.freeTimeLabel(params.data.priceFclExtra)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DestinationPort') + this.$t('CargoMsg.Cargo_Airline'), field: 'podLane', colId: 'podLane', width: 200, hide: true, suppressColumnsToolPanel: true,
          cellRenderer: (params) => {
            return this.regionLabel(params)
          }
        },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          hide: true
        },
        { headerName: this.$t('Pricing.CabinState'), field: 'priceState', colId: 'priceState', width: 100,
          cellRenderer: (params) => {
            return PriceUtils.priceStateLabelFunc(params.value)
          }
        }
      ],
      spotGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      spotRowData: [],
      spot: {
        freightType: 1,
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      allGridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      allColumnDefs: [
        {
          headerName: ' ', checkboxSelection: true, maxWidth: 40,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          tooltipValueGetter: (params) => {
            return params.value
          } },
        {
          headerName: this.$t('Pricing.Carrier'), field: 'carrier', colId: 'carrier', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.companyShortNameLabelFun(params.value)
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.Vessel'), field: 'vessel', colId: 'vessel', width: 200
        },
        { headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', colId: 'voyageFlight', width: 200
        },
        { headerName: 'ETD', field: 'etd', colId: 'etd', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.Days'), field: 'days', colId: 'days', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.daysColumnLabelFunc(params.data, params.data.days)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return PriceUtils.daysColumnLabelFunc(params.data, params.data.days)
          } },
        { headerName: this.$t('Pricing.Lane'), field: 'lane', colId: 'lane', width: 200 },
        { headerName: this.$t('Pricing.Dock'), field: 'dock', colId: 'dock', width: 200 },
        { headerName: this.$t('Pricing.DestinationDock'), field: 'destinationDock', colId: 'destinationDock', width: 200 },
        {
          headerName: this.$t('Pricing.Direct'), field: 'direct', colId: 'direct', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.boolLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Pricing.TraditionalRemarks'), field: 'remarks_1', colId: 'remarks_1', width: 200,
          cellRenderer: (params) => {
            if (!params.data) {
              return ''
            }
            const traditionalPrice = params.data.freightType === PriceConstant.PRICE_TYPE_TRADITIONAL.code ? params.data : params.data.traditionalPrice
            if (!traditionalPrice) { // 一致时替换data为spot数据
              return ''
            }
            return traditionalPrice.remarks
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data) {
              return ''
            }
            const traditionalPrice = params.data.freightType === PriceConstant.PRICE_TYPE_TRADITIONAL.code ? params.data : params.data.traditionalPrice
            if (!traditionalPrice) { // 一致时替换data为spot数据
              return ''
            }
            return traditionalPrice.remarks
          }
        },
        { headerName: this.$t('Pricing.ECommerceRemarks'), field: 'remarks', colId: 'remarks', width: 200,
          cellRenderer: (params) => {
            if (!params.data || params.data.freightType !== PriceConstant.PRICE_TYPE_SPOT.code) {
              return ''
            }
            return params.data.remarks
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data || params.data.freightType !== PriceConstant.PRICE_TYPE_SPOT.code) {
              return ''
            }
            return params.data.remarks
          }
        },
        {
          headerName: '20\'(' + this.$t('Pricing.Traditional') + ')', field: 'cost20_1', colId: 'cost20_1', width: 200,
          cellRenderer: (params) => {
            return this.formatTraditional(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.formatTraditional(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.formatTraditional(params))
          }
        },
        {
          headerName: '40\'(' + this.$t('Pricing.Traditional') + ')', field: 'cost40_1', colId: 'cost40_1', width: 200,
          cellRenderer: (params) => {
            return this.formatTraditional(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.formatTraditional(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.formatTraditional(params))
          }
        },
        {
          headerName: '40\' HC(' + this.$t('Pricing.Traditional') + ')', field: 'costhc_1', colId: 'costhc_1', width: 200,
          cellRenderer: (params) => {
            return this.formatTraditional(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.formatTraditional(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.formatTraditional(params))
          }
        },
        {
          headerName: '20\' NOR(' + this.$t('Pricing.Traditional') + ')', field: 'cost20nor_1', colId: 'cost20nor_1', width: 200,
          cellRenderer: (params) => {
            return this.formatTraditional(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.formatTraditional(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.formatTraditional(params))
          }
        },
        {
          headerName: '40\' NOR(' + this.$t('Pricing.Traditional') + ')', field: 'cost40nor_1', colId: 'cost40nor_1', width: 200,
          cellRenderer: (params) => {
            return this.formatTraditional(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.formatTraditional(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.formatTraditional(params))
          }
        },
        {
          headerName: '45\'(' + this.$t('Pricing.Traditional') + ')', field: 'cost45_1', colId: 'cost45_1', width: 200,
          cellRenderer: (params) => {
            return this.formatTraditional(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.formatTraditional(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.formatTraditional(params))
          }
        },
        { headerName: 'Free Time' + '(' + this.$t('Pricing.Traditional') + ')', field: 'freeTime_1', colId: 'freeTime_1', width: 200,
          cellRenderer: (params) => {
            if (!params.data) {
              return ''
            }
            const traditionalPrice = params.data.freightType === PriceConstant.PRICE_TYPE_TRADITIONAL.code ? params.data : params.data.traditionalPrice
            if (!traditionalPrice) { // 一致时替换data为spot数据
              return ''
            }
            return this.freeTimeLabel(traditionalPrice.priceFclExtra)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (!params.data) {
              return ''
            }
            const traditionalPrice = params.data.freightType === PriceConstant.PRICE_TYPE_TRADITIONAL.code ? params.data : params.data.traditionalPrice
            if (!traditionalPrice) { // 一致时替换data为spot数据
              return ''
            }
            return traditionalPrice.priceFclExtra ? traditionalPrice.priceFclExtra.freeContainerPeriod : ''
          }
        },
        { headerName: 'Free Time' + '(' + this.$t('Pricing.ECommerce') + ')', field: 'freeTime', colId: 'freeTime', width: 200,
          cellRenderer: (params) => {
            if (params.data.freightType === PriceConstant.PRICE_TYPE_TRADITIONAL.code) {
              return ''
            }
            return this.freeTimeLabel(params.data.priceFclExtra)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data.freightType === PriceConstant.PRICE_TYPE_TRADITIONAL.code) {
              return ''
            }
            return this.freeTimeLabel(params.data.priceFclExtra)
          }
        },
        {
          headerName: '20\'(' + this.$t('Pricing.ECommerce') + ')', field: 'cost20', colId: 'cost20', width: 200,
          cellRenderer: (params) => {
            return this.formatSpot(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.formatSpot(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.formatSpot(params))
          }
        },
        {
          headerName: '40\'(' + this.$t('Pricing.ECommerce') + ')', field: 'cost40', colId: 'cost40', width: 200,
          cellRenderer: (params) => {
            return this.formatSpot(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.formatSpot(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.formatSpot(params))
          }
        },
        {
          headerName: '40\' HC(' + this.$t('Pricing.ECommerce') + ')', field: 'costhc', colId: 'costhc', width: 200,
          cellRenderer: (params) => {
            return this.formatSpot(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.formatSpot(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.formatSpot(params))
          }
        },
        {
          headerName: '20\' NOR(' + this.$t('Pricing.ECommerce') + ')', field: 'cost20nor', colId: 'cost20nor', width: 200,
          cellRenderer: (params) => {
            return this.formatSpot(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.formatSpot(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.formatSpot(params))
          }
        },
        {
          headerName: '40\' NOR(' + this.$t('Pricing.ECommerce') + ')', field: 'cost40nor', colId: 'cost40nor', width: 200,
          cellRenderer: (params) => {
            return this.formatSpot(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.formatSpot(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.formatSpot(params))
          }
        },
        {
          headerName: '45\'(' + this.$t('Pricing.ECommerce') + ')', field: 'cost45', colId: 'cost45', width: 200,
          cellRenderer: (params) => {
            return this.formatSpot(params)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.formatSpot(params)
          },
          cellStyle: (params) => {
            return PriceUtils.setCellColor(params.data, true, params.colDef.field)
          },
          tooltipValueGetter: (params) => {
            return PriceUtils.setTooltip(params.data, true, params.colDef.field)
          },
          excelRenderer: (params) => {
            return this.priceColumnExportLabelFunc(this.formatSpot(params))
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DestinationPort') + this.$t('CargoMsg.Cargo_Airline'), field: 'podLane', colId: 'podLane', width: 200, hide: true, suppressColumnsToolPanel: true,
          cellRenderer: (params) => {
            return this.regionLabel(params)
          }
        },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
          },
          hide: true
        },
        { headerName: this.$t('Pricing.CabinState'), field: 'priceState', colId: 'priceState', width: 100,
          cellRenderer: (params) => {
            return PriceUtils.priceStateLabelFunc(params.value)
          }
        }
      ],
      allRowData: [],
      all: {
        freightType: 2,
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pageCount: 0
      },
      surchargeFcl: {
        allSurchargeFclList: [],
        bookingAgentMap: new Map(),
        carrierMap: new Map(),
        polMap: new Map(),
        podMap: new Map(),
        laneMap: new Map()
      }
    }
  },
  computed: {
    gridConfigModule() {
      if (this.tabName === 'TraditionalFreightRates') {
        return '22320102'
      }
      if (this.tabName === 'SpotFreightRates') {
        return '22320103'
      }
      return '22320104'
    },
    tipWidth() {
      return this.$store.getters.language === 'zh' ? 'left190' : 'left330'
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      async handler() {
        this.customSearchItems = await this.getCustomSearchItems()
      }
    }
  },
  created() {
    this.init()
    this.loadSurcharge()
  },
  methods: {
    onReset() {},
    async exportExcel() {
      // 添加确认导出
      let flag = false
      const level = CommonState.getNameByCode(PriceConstant.PRICE_LEVELS, this.filter.level)
      await this.$confirm(this.$t('Pricing.TariffTableExportLevelTips', [level]), this.$t('Pricing.TariffTableExportLevelTitleTips'), {
        confirmButtonText: this.$t('Pricing.CONFIRM'),
        cancelButtonText: this.$t('Pricing.Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        flag = true
      }).catch(() => {
      })
      if (!flag) {
        return
      }
      const params = deepClone(this.getFilter())
      const condition = this.$refs.tariffTable.getAdvData()
      console.info('condition', condition)
      params.conditions = condition.conditions
      if (this.checkDate(params)) {
        return
      }
      params.paging = false
      params.pageNum = null
      const { columnApi, api } = this.gridOptions()
      const fileName = 'TariffTable'
      this.fullscreenLoading = getLoading()
      queryTariffTable(params).then(async(res) => {
        this.initSurchargeFcl(res)
        this.fullscreenLoading.close()
        const rows = this.getRowData(res.data.priceFclPageInfo.list)
        if (rows.length === 0) {
          this.$message.warning(this.$t('Pricing.NoRecord'))
          return
        }
        // 获取显示列
        const allDisplayedColumns = columnApi.getAllDisplayedColumns()
        const sortList = api.getSortModel() // 获取排序结果
        const sortMap = {}
        if (sortList.length > 0) {
          for (const sort of sortList) {
            sortMap[sort['colId']] = sort['sort']
          }
        } else {
          sortMap['carrier'] = 'asc'
          sortMap['pod'] = 'asc'
          sortMap['etd'] = 'asc'
          sortMap['freightType'] = 'asc'
        }
        const column = api.columnController.gridColumnsMap['podLane']
        allDisplayedColumns.push(column)
        const wb = await getExcelWbMoreSheetByGroup(fileName, rows, [...allDisplayedColumns], 'podLane', true, null, ['podLane'], sortMap)
        this.uploadAndDownloadFile(wb)
        this.$message.success(this.$t('Message.RequestSucceededExporting'))
      }).catch(async() => {
        this.fullscreenLoading.close()
      })
    },
    async init() {
      this.customSearchItems = await this.getCustomSearchItems()
    },
    // 组装查询条件
    async getCustomSearchItems() {
      let searchField = new AdvancedSearchField()
      const defaultSearchFields = []
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'date'
      searchField.fieldType = 'FIELD_DATE_RANGE'
      searchField.filterType = 'THREE_MONTH'
      searchField.itemCondition = []
      searchField.subType = 'range'
      searchField.defaultConditionVal = ''
      searchField.itemName = 'price.ETD'
      searchField.itemLabel = 'ETD'
      searchField.itemValue = []
      searchField.selected = 0
      searchField.valueExpression = ''
      searchField.lock = false
      searchField.defaultValue = []
      // 设置默认日期范围
      const startDate = new Date() // 起始日期（今天）
      // 设置 defaultValue 为格式化后的日期范围
      searchField.defaultValue = [this.formatDate(startDate), this.formatDate(new Date(startDate.getTime() + (90 * 24 * 60 * 60 * 1000)))] // 默认开始时间+90天
      defaultSearchFields.push(searchField.formatObj2Json())
      return defaultSearchFields
    },
    // 格式化日期为 YYYY-MM-DD
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // 月份补零
      const day = String(date.getDate()).padStart(2, '0') // 日期补零
      return `${year}-${month}-${day}`
    },
    checkDate(params) {
      // 有效期是否满足三个月范围
      if (!AdvancedSearchOption.hasField('price.BEGIN_DATE', params.conditions) && !AdvancedSearchOption.hasField('price.ETD', params.conditions)) {
        // 需要维护有效期
        this.$message.warning(this.$t('Pricing.EitherETDOrValidityPeriodMustBeFilledIn'))
        return true
      }
      if (AdvancedSearchOption.hasField('price.ETD', params.conditions)) {
        const option = AdvancedSearchOption.getOption('price.ETD', params.conditions)
        if (!(option.value.includes('start') && option.value.includes('end'))) {
          this.$message.warning(this.$t('Pricing.theSelectedETDCannotExceed3Months'))
          return true
        }
      }
      if (AdvancedSearchOption.hasField('price.BEGIN_DATE', params.conditions)) {
        const option = AdvancedSearchOption.getOption('price.BEGIN_DATE', params.conditions)
        if (option.operator !== OperatorConstants.OPERATOR_RANGE.code) {
          this.$message.warning(this.$t('Pricing.theSelectedValidityPeriodCannotExceed3Months'))
          return true
        }

        if (option) {
          let start = null
          let end = null
          const items = option.value.split(',')
          for (let i = 1; i < items.length && i < 3; ++i) {
            if (items[i].startsWith('start=')) {
              start = items[i].substr(6)
            } else if (items[i].startsWith('end=')) {
              end = items[i].substr(4)
            }
          }
          if (!start || !end) {
            this.$message.warning(this.$t('Pricing.theSelectedValidityPeriodCannotExceed3Months'))
            return true
          }
          //
          const day = dateUtils.isWithinMonths(start, end, 3)
          if (!day) {
            this.$message.warning(this.$t('Pricing.theSelectedValidityPeriodCannotExceed3Months'))
            return true
          }
        }
      }
      return false
    },
    uploadAndDownloadFile(workbook) {
      // 将Workbook转换为二进制数据
      const excelData = XLSX.write(workbook, {
        type: 'array',
        bookType: 'xlsx'
      })

      // 创建一个Blob对象来存储二进制数据
      const blob = new Blob([excelData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })

      // 创建一个FormData对象，用于上传文件
      const formData = new FormData()
      formData.append('file', blob, 'data.xlsx') // 将Blob对象附加到FormData中
      transformedTariffTableExcel(formData).then(res => {
        convertResToBlob(res)
      })
    },
    configureTheSurcharge() {
      this.configureTheSurchargeDialog.visible = true
    },
    handleTabClick() {},
    queryHandler(data) {
      const params = this.getFilter()
      if (data) {
        params.conditions = data.conditions
      }
      if (this.checkDate(params)) {
        return
      }
      this.fullscreenLoading = getLoading()
      queryTariffTable(params).then((res) => {
        this.initSurchargeFcl(res)
        this.fullscreenLoading.close()
        this.setRowData(res.data)
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    initSurchargeFcl(res) {
      // 附加费Map初始化【对应后端方法：matchSurchargeFcl】
      this.surchargeFcl = {
        allSurchargeFclList: [],
        bookingAgentMap: new Map(),
        carrierMap: new Map(),
        polMap: new Map(),
        podMap: new Map(),
        laneMap: new Map()
      }
      if (res.data.surchargeFclList && res.data.surchargeFclList.length > 0) {
        for (const surchargeFcl of res.data.surchargeFclList) {
          if (this.surchargeFcl.bookingAgentMap.get(surchargeFcl.bookingAgent) && this.surchargeFcl.bookingAgentMap.get(surchargeFcl.bookingAgent).length > 0) {
            this.surchargeFcl.bookingAgentMap.set(surchargeFcl.bookingAgent, [...this.surchargeFcl.bookingAgentMap.get(surchargeFcl.bookingAgent), surchargeFcl])
          } else {
            this.surchargeFcl.bookingAgentMap.set(surchargeFcl.bookingAgent, [surchargeFcl])
          }
          if (this.surchargeFcl.carrierMap.get(surchargeFcl.carrier) && this.surchargeFcl.carrierMap.get(surchargeFcl.carrier).length > 0) {
            this.surchargeFcl.carrierMap.set(surchargeFcl.carrier, [...this.surchargeFcl.carrierMap.get(surchargeFcl.carrier), surchargeFcl])
          } else {
            this.surchargeFcl.carrierMap.set(surchargeFcl.carrier, [surchargeFcl])
          }
          if (this.surchargeFcl.polMap.get(surchargeFcl.pol) && this.surchargeFcl.polMap.get(surchargeFcl.pol).length > 0) {
            this.surchargeFcl.polMap.set(surchargeFcl.pol, [...this.surchargeFcl.polMap.get(surchargeFcl.pol), surchargeFcl])
          } else {
            this.surchargeFcl.polMap.set(surchargeFcl.pol, [surchargeFcl])
          }
          if (this.surchargeFcl.podMap.get(surchargeFcl.pod) && this.surchargeFcl.podMap.get(surchargeFcl.pod).length > 0) {
            this.surchargeFcl.podMap.set(surchargeFcl.pod, [...this.surchargeFcl.podMap.get(surchargeFcl.pod), surchargeFcl])
          } else {
            this.surchargeFcl.podMap.set(surchargeFcl.pod, [surchargeFcl])
          }
          if (this.surchargeFcl.laneMap.get(surchargeFcl.region) && this.surchargeFcl.laneMap.get(surchargeFcl.region).length > 0) {
            this.surchargeFcl.laneMap.set(surchargeFcl.region, [...this.surchargeFcl.laneMap.get(surchargeFcl.region), surchargeFcl])
          } else {
            this.surchargeFcl.laneMap.set(surchargeFcl.region, [surchargeFcl])
          }
        }
        this.surchargeFcl.allSurchargeFclList = res.data.surchargeFclList
      }
    },
    getFilter() {
      if (this.tabName === 'TraditionalFreightRates') {
        return this.traditional
      }
      if (this.tabName === 'SpotFreightRates') {
        return this.spot
      }
      return this.all
    },
    setRowData(data) {
      const total = Number(data.priceFclPageInfo.total)
      const list = data.priceFclPageInfo.list
      if (this.tabName === 'TraditionalFreightRates') {
        this.matchSurchargeFcl(list)
        this.traditionalRowData = list
        // 拆分数据
        this.traditional.total = total
        return
      }
      if (this.tabName === 'AllFreightRates') {
        // this.matchTraditional(list)
        this.matchSurchargeFcl(list)
        this.allRowData = list
        this.all.total = total
        this.all.pageCount = data.priceFclPageInfo.pages
        return
      }
      this.matchSurchargeFcl(list)
      this.spotRowData = list
      this.spot.total = total
    },
    getRowData(list) {
      this.matchSurchargeFcl(list)
      return list
    },
    splitRowData(list) {
      // 根据有效期，船期拆分数据
      const result = []
      if (list && list.length > 0) {
        for (const data of list) {
          const dateList = dateUtils.getDatesByWeekdays(data.beginDate, data.endDate, data.frequency8)
          if (dateList && dateList.length > 0) {
            for (const etd of dateList) {
              const item = deepClone(data)
              item.etd = etd
              result.push(item)
            }
          }
        }
      }
      this.matchSurchargeFcl(result)
      return result
    },
    onLevelChanged(p) {
      this.filter.level = p.value
      this.gridRefresh()
    },
    changeCurrency(p) {
      this.filter.currency = p.value
      this.gridRefresh()
    },
    gridRefresh() {
      const { api } = this.gridOptions()
      api.refreshCells({ force: true })
    },
    gridOptions() {
      if (this.tabName === 'TraditionalFreightRates') {
        return this.traditionalGridOptions
      }
      if (this.tabName === 'SpotFreightRates') {
        return this.spotGridOptions
      }
      return this.allGridOptions
    },
    getFreightType() {
      if (this.tabName === 'TraditionalFreightRates') {
        return 0
      }
      if (this.tabName === 'SpotFreightRates') {
        return 1
      }
      return 2
    },
    formatSpot(params) {
      if (params.data.freightType === PriceConstant.PRICE_TYPE_TRADITIONAL.code) {
        return ''
      }
      return this.priceColumnLabelFunc(params)
    },
    // 获取传统运价对应的SPOT ETD一致
    formatTraditional(params) {
      if (!params.data) {
        return ''
      }
      // 如果数据类型就是传统运价，则返回传统运价的数据
      // 如果数据类型就是电商运价，则返回电商运价对应的传统运价
      const traditionalPrice = params.data.freightType === PriceConstant.PRICE_TYPE_TRADITIONAL.code ? params.data : params.data.traditionalPrice
      if (!traditionalPrice) { // 一致时替换data为spot数据
        return ''
      }
      const field = params.colDef.field
      const data = {
        data: traditionalPrice,
        value: traditionalPrice[field],
        colDef: {
          field: field.substring(0, field.lastIndexOf('_'))
        }
      }
      return this.priceColumnLabelFunc(data)
    },
    matchTraditional(list) {
      if (!list || list.length === 0) {
        return
      }
      for (const fcl of list) {
        // 拆分传统运价
        if (fcl.traditionalPrices && fcl.traditionalPrices.length > 0) { // 一致时替换data为spot数据
          const targetEtd = ColumnUtils.dateLabelFunc(fcl.etd)
          // 遍历spot运价，匹配ETD一致的数据
          for (const traditionalPrice of fcl.traditionalPrices) {
            const dateList = dateUtils.getDatesByWeekdays(traditionalPrice.beginDate, traditionalPrice.endDate, traditionalPrice.frequency8)
            if (dateList && dateList.length > 0) {
              if (this.isSameEtd(dateList, targetEtd)) {
                fcl.traditionalPrice = traditionalPrice
                break
              }
            }
          }
        }
      }
    },
    isSameEtd(dateList, targetEtd) {
      for (const etd of dateList) {
        const sourceEtd = dateUtils.formatDate(etd, 'yyyy-MM-dd')
        if (sourceEtd === targetEtd) {
          return true
        }
      }
      return false
    },
    // 匹配附加费显示列
    matchSurchargeFcl(list) {
      if (!list || list.length === 0) {
        return
      }
      for (const fcl of list) {
        const sfMap = {} // 附加费名称map， key为附加费的费用名称，value为附加费
        this.matchSurchargeFclMap(sfMap, fcl)
        if (fcl.traditionalPrice) { // 如果是spot运价匹配传统运价时
          fcl.traditionalPrice.etd = fcl.etd
          this.matchSurchargeFclMap(sfMap, fcl.traditionalPrice)
        }
        fcl['surchargeFclMap'] = sfMap
      }
    },
    // 对应后端方法：matchSurchargeFcl
    matchSurchargeFclMap(sfMap, fcl) {
      // 判断是否有初次匹配的附加费
      // const surchargeFclList = fcl.surchargeFclList
      if (!this.surchargeFcl.allSurchargeFclList || this.surchargeFcl.allSurchargeFclList.length === 0) {
        return
      }
      let surchargeFclList = []
      // CARGO-40069 519巴士 运价-运价表查询网页丢失（匹配逻辑移动到前端）
      if (this.surchargeFcl.bookingAgentMap.get(fcl.bookingAgent) && this.surchargeFcl.bookingAgentMap.get(fcl.bookingAgent).length > 0) {
        surchargeFclList = [...this.surchargeFcl.bookingAgentMap.get(fcl.bookingAgent)]
      }
      if (this.surchargeFcl.carrierMap.get(fcl.carrier) && this.surchargeFcl.carrierMap.get(fcl.carrier).length > 0) {
        surchargeFclList = [...surchargeFclList, ...this.surchargeFcl.carrierMap.get(fcl.carrier)]
      }
      if (this.surchargeFcl.polMap.get(fcl.pol) && this.surchargeFcl.polMap.get(fcl.pol).length > 0) {
        surchargeFclList = [...surchargeFclList, ...this.surchargeFcl.polMap.get(fcl.pol)]
      }
      if (this.surchargeFcl.podMap.get(fcl.pod) && this.surchargeFcl.podMap.get(fcl.pod).length > 0) {
        surchargeFclList = [...surchargeFclList, ...this.surchargeFcl.podMap.get(fcl.pod)]
      }
      if (this.surchargeFcl.laneMap.get(fcl.lane) && this.surchargeFcl.laneMap.get(fcl.lane).length > 0) {
        surchargeFclList = [...surchargeFclList, ...this.surchargeFcl.laneMap.get(fcl.lane)]
      }
      if (surchargeFclList && surchargeFclList.length > 0) {
        const useSurchargeFcls = []
        for (const useSf of surchargeFclList) {
          // 区分当前运价直达情况匹配和中转匹配
          if (fcl.direct && !(useSf.directType === PriceConstant.UNLIMITED.code || useSf.directType === PriceConstant.DIRECT_ONLY.code)) {
            continue
          }
          if (!fcl.direct && !(useSf.directType === PriceConstant.UNLIMITED.code || useSf.directType === PriceConstant.TRANSIT_ONLY.code || useSf.directType === PriceConstant.TRANSIT_TO_PORT.code)) {
            continue
          }
          if (useSf.bookingAgent && useSf.bookingAgent !== fcl.bookingAgent) {
            continue
          }
          if (useSf.carrier && useSf.carrier !== fcl.carrier) {
            continue
          }
          if (useSf.pol && useSf.pol !== fcl.pol) {
            continue
          }
          if (useSf.pod && useSf.pod !== fcl.pod) {
            continue
          }
          if (useSf.pod && useSf.region) {
            const podPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', fcl.pod)
            if (useSf.region !== (podPort ? podPort.region : '')) {
              continue
            }
          }
          useSurchargeFcls.push(useSf)
        }
        // 遍历附加费
        if (useSurchargeFcls && useSurchargeFcls.length > 0) {
          for (const sf of useSurchargeFcls) {
            const mapKey = sf.chargeScaleCode + '_' + sf.freightType
            // 判断运价类型是否一致
            if (sf.freightType !== 2 && sf.freightType !== fcl.freightType) {
              continue
            }
            const etd = ColumnUtils.dateLabelFunc(fcl.etd)
            // 判断ETD 是否在附加费有效期内
            if (dateUtils.formatStandardDate(sf.beginDate) >= etd || dateUtils.formatStandardDate(sf.endDate) <= etd) {
              continue
            }
            // 判断附加费map是否已存在该附加费，若存在同名，则对比权重
            if (sfMap.hasOwnProperty(mapKey)) {
              // 判断两个附加费对应当前海运费的权重，并保留权重最大的附加费，若一致，则不处理
              const resultSf = this.compareSf(sfMap[mapKey], sf, fcl)
              sfMap[mapKey] = resultSf
              continue
            }
            sfMap[mapKey] = sf
          }
        }
      }
    },
    // 权重对比
    compareSf(source, target, fcl) {
      const sourceWeight = this.getWeight(source, fcl)
      const targetWeight = this.getWeight(target, fcl)
      if (targetWeight > sourceWeight) {
        return target
      }
      return source
    },
    getWeight(sf, fcl) {
      // 订舱代理：10000
      // 船公司：1000
      // 起运港：100
      // 目的港：10
      // 航线：1
      let weight = 0
      if (sf.bookingAgent && sf.bookingAgent === fcl.bookingAgent) {
        weight += 10000
      }
      if (sf.carrier && sf.carrier === fcl.carrier) {
        weight += 1000
      }
      if (sf.pol && sf.pol === fcl.pol) {
        weight += 100
      }
      if (sf.pod && sf.pod === fcl.pod) {
        weight += 10
      }
      const port = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', fcl.pod)
      if (sf.region && sf.region === (port ? port.region : '')) {
        weight += 1
      }
      return weight
    },
    loadSurcharge() {
      const traditionalMap = {}
      const spotMap = {}
      const allMap = {}
      querySurchargeFclConfig().then(res => {
        const result = res.data
        // 处理表格添加附加费显示列
        for (const item of result) {
          const name = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'scaleCode', item.chargeScaleCode, 'zhName')
          const fieldId = item.chargeScaleCode + '_' + item.freightType
          const newColumn = {
            headerName: name, field: fieldId, colId: fieldId, width: 200,
            cellRenderer: (params) => {
              return this.surchargeFclLabel(params)
            },
            filterParams: {},
            filterValueGetter: (params) => {
              return this.surchargeFclLabel(params)
            },
            tooltipValueGetter: (params) => {
              return this.surchargeFclLabel(params)
            }
          }
          if (!traditionalMap.hasOwnProperty(fieldId)) {
            if ([0, 2].indexOf(item.freightType) > -1) {
              this.traditionalColumnDefs.push(newColumn)
            }
          }
          traditionalMap[fieldId] = true

          if (!spotMap.hasOwnProperty(fieldId)) {
            if ([1, 2].indexOf(item.freightType) > -1) {
              this.spotColumnDefs.push(newColumn)
            }
          }
          spotMap[fieldId] = true
          if (!allMap.hasOwnProperty(fieldId)) {
            this.allColumnDefs.push(newColumn)
          }
          allMap[fieldId] = true
        }
        this.traditionalGridOptions.api.setColumnDefs(this.traditionalColumnDefs)
        this.spotGridOptions.api.setColumnDefs(this.spotColumnDefs)
        this.allGridOptions.api.setColumnDefs(this.allColumnDefs)
      })
    },
    sumLabelFunc(value) {
      if (value === PriceConstant.NIL || value === undefined) return ''
      return value
    },
    reload() {
      this.configureTheSurchargeDialog.visible = false
      const view = this.$store.getters.visitedViews.find(v => v.path === '/Price/TariffTable')
      destoryView(view)
      refreshView(view)
    },
    regionLabel(params) {
      if (!params.data.pod) {
        return '无航线'
      }
      const port = ColumnUtils.podRegionLabFunc(params.data.pod)
      return !port ? '无航线' : port
    },
    surchargeFclLabel(params) {
      const surchargeFclMap = params.data.surchargeFclMap
      if (surchargeFclMap) {
        const field = params.colDef.field
        const surchargeFcl = surchargeFclMap[field]
        if (surchargeFcl) {
          const currency = surchargeFcl.currency
          const casePrice = this.sumLabelFunc(surchargeFcl.casePrice)
          if (casePrice) {
            return currency + ' ' + casePrice
          }
          const sum20 = this.sumLabelFunc(surchargeFcl.sum20)
          const sum40 = this.sumLabelFunc(surchargeFcl.sum40)
          const sumhc = this.sumLabelFunc(surchargeFcl.sumhc)
          return currency + ' ' + sum20 + '/' + sum40 + '/' + sumhc
        }
      }
      return ''
    },
    freeTimeLabel(priceFclExtra) {
      if (!priceFclExtra || priceFclExtra.freeTimeNil) {
        return ''
      }
      if (priceFclExtra.freeContainerPeriodType === PriceConstant.FREE_TIME_CONSOLIDATE.code) {
        return this.$t('Pricing.NeedFreeBox', [priceFclExtra.freeContainerPeriod])
      }
      return this.$t('Pricing.FreeTimeCalculatedSeparately', [priceFclExtra.dem, priceFclExtra.det])
    },
    priceColumnLabelFunc(params) {
      const num = PriceUtils.priceColumnLabelFunc(params, this.filter.level, params.data['currency'], this.authedLevel)
      if (!num) {
        return ''
      }
      return params.data.currency + ' ' + num
    },
    priceColumnExportLabelFunc(priceLabel) {
      if (priceLabel === '') return priceLabel
      const strs = priceLabel.split(' ')
      if (strs.length > 1) {
        const number = parseFloat(strs[1])
        return !isNaN(number) ? (strs[0] + ' ' + Math.ceil(number)) : priceLabel
      }
      return priceLabel
    }
  }
}
</script>

<style lang="scss" scoped>

.tariff-table-search{
.left190{
  left: 190px;
}
.left330{
  left: 330px;
}
}
</style>
